import React, { useEffect, useState } from "react";
import { BackButton } from "../components/generics/BackButton";
import { PageTitle } from "../MapProduct/HeaderMapProduct/styles";
import { Row, Column } from "components/Layout/Grid";
import { FiltersHeaderContextProvider } from "contexts/FiltersHeader";
import ManagementFilters from "../components/ManagementFilters";
import searchFilterIcon from "img/search-filter.svg";
import SacScoreBar from "components/SacScoreBar";
import Text from "components/Text";
import ManagementIndicator from "../components/ManagementIndicator";
import ManagementPanelService from "services/managementPanel.service";
import ItemRate from "../components/ItemRate";
import { ManagementBarChart, PeriodOption } from "../components/ManagementBarChart";
import { format, parseISO, subDays } from "date-fns";
import { ModalTotalUnansweredItems } from "./ModalTotalUnansweredItems/ModalTotalUnansweredItems";
import { ModalLostItems } from "./ModalLostItems/ModalLostItems";
import { ModalPendingItems } from "./ModalPendingItems/ModalPendingItems";
import { ModalWonItems } from "./ModalWonItems/ModalWonItems";
import { ModalAnsweredItems } from "./ModalAnsweredItems/ModalAnsweredItems";
import { ModalItemsWithoutMapping } from "./ModalItemsWithoutMapping/ModalItemsWithoutMapping";
import { ModalReviewRate } from "./ModalReviewRate/ModalReviewRate";
import { ModalChangeRate } from "./ModalChangeRate/ModalChangeRate";
import "./styles.scss";

export const ManagementPanel: React.FC = () => {
  const _managementPanelService = new ManagementPanelService();

  const [taxaDeResposta, setResponseRate] = useState(0);

  const [answeredQuotations, setAnsweredQuotations] = useState({
    title: "Cotações Respondidas",
    value: "",
    loading: true,
    error: false,
  });

  const [totalQuotations, setTotalQuotations] = useState({
    title: "Cotações Recebidas",
    value: "",
    loading: true,
    error: false,
  });

  const [totalAnsweredItems, setTotalAnsweredItems] = useState({
    title: "Itens Respondidos no Portal",
    value: "",
    loading: true,
    error: false,
    showClickDetails: true,
  });

  const [reviewRate, setReviewRate] = useState({
    title: "Taxa de Revisão",
    value: "",
    loading: true,
    error: false,
    showClickDetails: true,
    typeCard: "alert" as const,
    typeValue: "percent" as const,
  });

  const [changeRatePercentage, setChangeRatePercentage] = useState({
    title: "Taxa de Alteração",
    value: "",
    loading: true,
    error: false,
    showClickDetails: true,
    typeCard: "alert" as const,
    typeValue: "percent" as const,
  });

  const [totalQuotationsWithoutMapping, setTotalQuotationsWithoutMapping] =
    useState({
      title: "Cotações sem De/Para",
      value: "",
      loading: true,
      error: false,
      showClickDetails: true,
      typeCard: "warning" as const,
    });

  const [totalUnansweredItems, setTotalUnansweredItems] = useState({
    title: "Itens Não Respondidos",
    value: "",
    loading: true,
    error: false,
    showClickDetails: true,
    typeCard: "warning" as const,
  });

  const [showErrorIconReviewRate, setShowErrorIconReviewRate] = useState(false);
  const [showErrorIconChangeRatePercentage, setShowErrorIconChangeRatePercentage] = useState(false);
  const [typeCardReviewRate, setTypeCardReviewRate] = useState("alert");
  const [temporalEvolution, setTemporalEvolution] = useState({
    data: [] as any[],
  });

  const [wonItemsCount, setWonItemsCount] = useState(0);
  const [lostItemsCount, setLostItemsCount] = useState(0);
  const [pendingItemsCount, setPendingItemsCount] = useState(0);

  const [filterCurrent, setFilterCurrent] = useState<any>({});
  const [selectedBarChartPeriod, setSelectedBarChartPeriod] = useState<PeriodOption>(0);

  const [showModalTotalUnansweredItems, setShowModalTotalUnansweredItems] = useState(false);
  const [showModalLostItems, setShowModalLostItems] = useState(false);
  const [showModalPendingItems, setShowModalPendingItems] = useState(false);
  const [showModalWonItems, setShowModalWonItems] = useState(false);
  const [showModalAnsweredItems, setShowModalAnsweredItems] = useState(false);
  const [showModalItemsWithoutMapping, setShowModalItemsWithoutMapping] = useState(false);
  const [showModalReviewRate, setShowModalReviewRate] = useState(false);
  const [showModalChangeRate, setShowModalChangeRate] = useState(false);

  const [indicatorTotalDataInsightsRAItems, setIndicatorTotalDataInsightsRAItems] = useState(0);

  function openModalTotalUnansweredItems() {
    setShowModalTotalUnansweredItems(true);
  }

  function openModalLostItems() {
    setShowModalLostItems(true);
  }

  function openModalPendingItems() {
    setShowModalPendingItems(true);
  }

  function openModalWonItems() {
    setShowModalWonItems(true);
  }

  function openModalAnsweredItems() {
    setShowModalAnsweredItems(true);
  }

  function openModalItemsWithoutMapping() {
    setShowModalItemsWithoutMapping(true);
  }

  function openModalReviewRate() {
    setShowModalReviewRate(true);
  }

  function openModalChangeRate() {
    setShowModalChangeRate(true);
  }

  useEffect(() => {
    async function fetchTemporalEvolution() {
      const filterMapping = {
        BusinessUnitIdentifier: filterCurrent?.BusinessUnitIdentifier,
        SellerCodes: filterCurrent?.SellerCodes,
        MonthOffset: selectedBarChartPeriod,
      };
      await getTemporalEvolution(filterMapping, selectedBarChartPeriod);
    }
    const requiredFields = ['BusinessUnitIdentifier', 'SellerCodes'];
    if (requiredFields.every(field => filterCurrent[field])) {
      fetchTemporalEvolution();
    }
  }, [selectedBarChartPeriod]);

  function loadIndicators() {
    setTotalQuotations({ ...totalQuotations, loading: true });
    setAnsweredQuotations({
      ...answeredQuotations,
      loading: true,
    });
    setTotalAnsweredItems({ ...totalAnsweredItems, loading: true });
    setReviewRate({ ...reviewRate, loading: true });
    setChangeRatePercentage({ ...changeRatePercentage, loading: true });
    setTotalQuotationsWithoutMapping({
      ...totalQuotationsWithoutMapping,
      loading: true,
    });
    setTotalUnansweredItems({
      ...totalUnansweredItems,
      loading: true,
    });
    setShowErrorIconReviewRate(false);
    setTypeCardReviewRate("default");
    setTemporalEvolution({ data: [] as any[] });
  }

  function formatToApiDateTime(dateStr: string, timePart: "start" | "end"): string {
    const dateOnly = dateStr.length === 10;
    const date = dateOnly ? parseISO(`${dateStr}T12:00:00`) : parseISO(dateStr);
    const time = timePart === "start" ? "00:00:00" : "23:59:59";
    return `${format(date, "yyyy-MM-dd")}T${time}-03:00`;
  }

  async function refreshManagementPanel(filter: any) {
    loadIndicators();

    const starDateLast31Days = subDays(new Date(), 31);
    const endDateLast31Days = new Date();
    const defaultStartDate = format(starDateLast31Days, "yyyy-MM-dd");
    const defaultEndDate = format(endDateLast31Days, "yyyy-MM-dd");
    const startDate = formatToApiDateTime(filter.startDate || defaultStartDate, "start");
    const endDate = formatToApiDateTime(filter.endDate || defaultEndDate, "end");

    const filterMapping = {
      ProductCategories: filter.category,
      SellerCodes: filter.seller,
      Origin: filter.origin,
      BusinessUnitIdentifier: filter.subsidiary,
      StartDate: startDate,
      EndDate: endDate,
    };

    setFilterCurrent({...filterMapping});

    const respTotalQuotations =
      await _managementPanelService.getTotalQuotations(filterMapping);
    setTotalQuotations({
      ...totalQuotations,
      loading: false,
      value: respTotalQuotations,
    });

    const respAnsweredQuotations =
      await _managementPanelService.getAnsweredQuotations(filterMapping);
    setAnsweredQuotations({
      ...answeredQuotations,
      loading: false,
      value: respAnsweredQuotations,
    });

    const responseRate = (respAnsweredQuotations / respTotalQuotations) * 100;
    setResponseRate(Number(responseRate.toFixed(0)) || 0);

    const respReviewRate = await _managementPanelService.getReviewRate(
      filterMapping
    );
    setReviewRate({
      ...reviewRate,
      loading: false,
      value: `${respReviewRate.toString()}`,
    });

    setShowErrorIconReviewRate(respReviewRate < 50 ? true : false);
    setTypeCardReviewRate(respReviewRate < 50 ? "alert" : "default");

    const respChangeRatePercentage =
      await _managementPanelService.getChangeRatePercentage(filterMapping);
    setChangeRatePercentage({
      ...changeRatePercentage,
      loading: false,
      value: `${respChangeRatePercentage.toString()}`,
    });
    setShowErrorIconChangeRatePercentage(respChangeRatePercentage < 50 ? true : false);

    const respTotalQuotationsWithoutMapping =
      await _managementPanelService.getTotalQuotationsWithoutMapping(
        filterMapping
      );
    setTotalQuotationsWithoutMapping({
      ...totalQuotationsWithoutMapping,
      loading: false,
      value: respTotalQuotationsWithoutMapping,
    });

    const respTotalUnansweredItems =
      await _managementPanelService.getTotalUnansweredItems(filterMapping);
    setTotalUnansweredItems({
      ...totalUnansweredItems,
      loading: false,
      value: respTotalUnansweredItems,
    });

    const respTotalAnsweredItems =
      await _managementPanelService.getTotalAnsweredItems(filterMapping);
    setTotalAnsweredItems({
      ...totalAnsweredItems,
      loading: false,
      value: respTotalAnsweredItems,
    });

    await getTemporalEvolution(filterMapping);

    setSelectedBarChartPeriod(0);

    const toSafeCount = (resp: any): number => {
      if (typeof resp === "number") return resp;
      if (resp?.error) return 0;
      if (typeof resp?.data === "number") return resp.data;
      if (typeof resp?.total === "number") return resp.total;
      return 0;
    };

    const respIndicatorTotalDataInsightRAItems = await _managementPanelService.getDataInsightsRAItemsByStatus(undefined, filterMapping);
    setIndicatorTotalDataInsightsRAItems(toSafeCount(respIndicatorTotalDataInsightRAItems));

    const respWonItemsCount = await _managementPanelService.getDataInsightsRAItemsByStatus(2, filterMapping);
    setWonItemsCount(toSafeCount(respWonItemsCount));

    const respPendingItemsCount = await _managementPanelService.getDataInsightsRAItemsByStatus(0, filterMapping);
    setPendingItemsCount(toSafeCount(respPendingItemsCount));

    const respLostItemsCount = await _managementPanelService.getDataInsightsRAItemsByStatus(1, filterMapping);
    setLostItemsCount(toSafeCount(respLostItemsCount));
  }

  async function getTemporalEvolution(filter: any, period?: PeriodOption) {
    try {
      const respTemporalEvolution = await _managementPanelService.getTemporalEvolution(filter);
      const newData = respTemporalEvolution?.data || [];
      const currentPeriod = period !== undefined ? period : selectedBarChartPeriod;
      const MONTHS_TO_ACCUMULATE = 6;

      setTemporalEvolution((prevState) => {
        if (currentPeriod === 3) {
          const previousData = prevState.data || [];
          
          const combinedData = [...newData, ...previousData];
          
          const accumulatedData = combinedData.length > MONTHS_TO_ACCUMULATE
            ? combinedData.slice(-MONTHS_TO_ACCUMULATE)
            : combinedData;
          
          return { 
            data: accumulatedData 
          };
        }
        
        return { 
          data: newData 
        };
      });
    } catch (error) {
      setTemporalEvolution({ data: [] });
    }
  }

  return (
    <>
      <BackButton />
      <PageTitle size={24} className="color-blue-gray">
        Painel de Gestão
      </PageTitle>

      <Row className="py-3 pt-md-0 flex-lg-column">
        <Column className="w-100 w-lg-100 px-3 pr-3 pt-3 bg-primary pl-sm-3 pl-md-3 pl-lg-3 dashboard-panel">
          <FiltersHeaderContextProvider>
            <ManagementFilters updateFilter={refreshManagementPanel} />
          </FiltersHeaderContextProvider>
        </Column>
      </Row>

      {totalQuotations.value === "" && (
        <Row className="pt-md-0 flex-lg-column">
          <Column className="w-100 w-lg-100 px-3 bg-white pl-sm-3 pl-md-3 pl-lg-3 dashboard-panel height-500">
            <div
              className="d-flex flex-column justify-content-center align-center w-100"
              style={{ height: "480px" }}
            >
              <img
                src={searchFilterIcon}
                alt="searchFilterIcon"
                className="w-100 h-100"
                style={{
                  width: "109px",
                  height: "94px",
                  marginTop: "137px",
                  marginBottom: "25px",
                }}
              />
              <h2
                className="color-blue-gray font-bold text-center"
                style={{ lineHeight: "1.2" }}
              >
                Bem-vindo(a) ao Painel de Gestão!
              </h2>
              <h2
                className="color-blue-gray text-center w-100"
                style={{ width: "28rem", lineHeight: "1.2" }}
              >
                Para visualizar os indicadores selecione os filtros no topo da
                tela e clique em 'Filtrar'
              </h2>
            </div>
          </Column>
        </Row>
      )}

      {totalQuotations.value !== "" && (
        <>
          <Row className="pt-md-0 flex-lg-column mt-3">
            <Column className="w-100 w-lg-100 px-3 bg-white pl-sm-3 pl-md-3 pl-lg-3 dashboard-panel height-500 py-1 pb-4">
              <Row className="pt-md-0 flex-lg-column mt-3">
                <Column className="w-100 w-lg-100">
                  <Text size={24} className="font-bold color-primary">
                    Taxa de Resposta: {taxaDeResposta}%
                  </Text>
                </Column>
                <Column className="w-100 w-lg-100">
                  <Text size={20} className="color-blue-gray text-right">
                    <span className="font-bold">
                      {answeredQuotations.value}
                    </span>{" "}
                    Cotações Respondidas de{" "}
                    <span className="font-bold">{totalQuotations.value}</span>{" "}
                    Cotações Recebidas
                  </Text>
                </Column>
              </Row>
              <SacScoreBar score={taxaDeResposta} />
            </Column>
          </Row>

          <Row className="pt-md-0 flex-lg-column mt-3">
            <Column className="w-100 w-lg-100 px-3 pl-sm-3 pl-md-3 pl-lg-3 dashboard-panel py-1">
              <Text size={24} className="font-bold color-primary">
                Indicadores de produtividade
              </Text>
            </Column>
          </Row>

          <Row className="pt-md-0 flex-lg-column">
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={totalQuotations}
                tooltipContent={""}
                tooltipPlace={"top"}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={answeredQuotations}
                tooltipContent={""}
                tooltipPlace={"top"}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={totalAnsweredItems}
                tooltipContent={""}
                tooltipPlace={"top"}
                showClickDetails={true}
                onClick={openModalAnsweredItems}
              />
            </Column>
          </Row>

          <Row className="pt-md-0 flex-lg-column">
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={reviewRate}
                tooltipContent={""}
                tooltipPlace={"top"}
                showClickDetails={true}
                showErrorIcon={showErrorIconReviewRate}
                isReviewRateOrChangeRatePercentage={true}
                onClick={openModalReviewRate}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={changeRatePercentage}
                tooltipContent={""}
                tooltipPlace={"top"}
                showClickDetails={true}
                showErrorIcon={showErrorIconChangeRatePercentage}
                isReviewRateOrChangeRatePercentage={true}
                onClick={openModalChangeRate}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={totalQuotationsWithoutMapping}
                tooltipContent={""}
                tooltipPlace={"top"}
                showClickDetails={true}
                onClick={openModalItemsWithoutMapping}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ManagementIndicator
                data={totalUnansweredItems}
                tooltipContent={""}
                tooltipPlace={"top"}
                showClickDetails={true}
                onClick={openModalTotalUnansweredItems}
              />
            </Column>
          </Row>
          
          <ManagementBarChart
            data={temporalEvolution.data}
            selectedPeriod={selectedBarChartPeriod}
            onPeriodChange={setSelectedBarChartPeriod}
          />

          <Row className="pt-md-0 flex-lg-column">
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ItemRate
                titleCard="Itens Ganhos"
                answeredQuotations={wonItemsCount}
                totalAnsweredItems={indicatorTotalDataInsightsRAItems}
                typeCard="won"
                onClick={openModalWonItems}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ItemRate
                titleCard="Itens Pendentes"
                answeredQuotations={pendingItemsCount}
                totalAnsweredItems={indicatorTotalDataInsightsRAItems}
                typeCard="pending"
                onClick={openModalPendingItems}
              />
            </Column>
            <Column className="w-100 w-lg-100 px-1 pl-sm-3 pl-md-3 pl-lg-3">
              <ItemRate
                titleCard="Itens Perdidos"
                answeredQuotations={lostItemsCount}
                totalAnsweredItems={indicatorTotalDataInsightsRAItems}
                typeCard="lost"
                onClick={openModalLostItems}
              />
            </Column>
          </Row>
        </>
      )}

      <ModalTotalUnansweredItems
        open={showModalTotalUnansweredItems}
        onClose={() => setShowModalTotalUnansweredItems(false)}
        filterCurrent={filterCurrent}
      />

      <ModalLostItems
        open={showModalLostItems}
        onClose={() => setShowModalLostItems(false)}
        filterCurrent={filterCurrent}
      />

      <ModalPendingItems
        open={showModalPendingItems}
        onClose={() => setShowModalPendingItems(false)}
        filterCurrent={filterCurrent}
      />

      <ModalWonItems
        open={showModalWonItems}
        onClose={() => setShowModalWonItems(false)}
        filterCurrent={filterCurrent}
      />

      <ModalAnsweredItems
        open={showModalAnsweredItems}
        onClose={() => setShowModalAnsweredItems(false)}
        filterCurrent={filterCurrent}
      />

      <ModalItemsWithoutMapping
        open={showModalItemsWithoutMapping}
        onClose={() => setShowModalItemsWithoutMapping(false)}
        filterCurrent={filterCurrent}
      />

      <ModalReviewRate
        open={showModalReviewRate}
        onClose={() => setShowModalReviewRate(false)}
        filterCurrent={filterCurrent}
      />

      <ModalChangeRate
        open={showModalChangeRate}
        onClose={() => setShowModalChangeRate(false)}
        filterCurrent={filterCurrent}
      />
    </>
  );
};
